
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPropulsion as ObiPropulsionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-propulsion.js';
 
 
 

 
 export const ObiPropulsion = createComponent({
   react: React,
   tagName: 'obi-propulsion',
   elementClass: ObiPropulsionElement,
   events: {
     
   }
  });
 
 